var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"mt-2",attrs:{"icon":"","title":"Upload data from Excel","loading":_vm.isLoading},on:{"click":_vm.openFileDialog}},[_c('v-icon',[_vm._v(_vm._s(_vm.mdiDatabaseImport))])],1),_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"input":_vm.upload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }